<template>
  <v-app>
    <div>
      <template v-if="currentProduct && showProductModal">
        <modal-product
          :categories="filterCategory"
          style="min-height: 100vh"
          v-model="currentProduct"
          :key="currentProduct.sku"
          :pageProfile="pageProfile"
          @addToCart="addToCart"
          @close="closeProduct"
          @openCheckout="openCheckout"
          :loading-cart="loadingCart"
        ></modal-product>
      </template>

      <!-- Checkout detail -->
      <div
        v-if="showModal"
        style="min-height: 100vh"
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card class="hide-overflow" style="min-height: 100vh">
          <v-toolbar color="transparent" flat>
            <v-btn icon @click="close()" :disabled="checkoutLoading">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t('Checkout Cart') }}</v-toolbar-title>
          </v-toolbar>

          <div :style="{ 'padding-bottom': voucher ? '200px' : '100px' }">
            <template v-if="loadingCart">
              <div class="text-xs-center">
                <v-progress-circular
                  :key="theme.color"
                  indeterminate
                  :color="theme.color"
                ></v-progress-circular>
              </div>
            </template>
            <template v-else-if="cart.length > 0">
              <template v-for="(item, index) in cart">
                <checkout-item
                  :categories="filterCategory"
                  :key="'cart_' + index + '_' + timestamp"
                  v-model="cart[index]"
                  :loading="checkoutLoading"
                  @deleteItem="deleteItemInCart(index)"
                  @onUpdateStock="onUpdateStock"
                  @showProduct="showProduct"
                  :stock="[]"
                  :isTero="true"
                  :currentCategory="currentCategory.title"
                ></checkout-item>
              </template>
            </template>
            <template v-else>
              <div class="text-xs-center pt-4 pb-4">
                <p>{{ $t('No product') }}</p>
              </div>
            </template>
          </div>

          <v-card
            style="position: fixed; z-index: 3; bottom: 0; left: 0; right: 0"
          >
            <v-layout wrap>
              <template v-if="cart.length >= 1">
                <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">{{
                  $t('Total')
                }}</v-flex>
                <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2 text-xs-right"
                  >{{ currencySign }}{{ totalPrice | decimalFormat }}</v-flex
                >
              </template>
              <v-flex xs12>
                <template v-if="isCartOutOfStock">
                  <div class="text-xs-center pa-3 grey lighten-2">
                    <span>
                      {{
                        $t(
                          'Not enough products in stock, please try to order again.'
                        )
                      }}
                    </span>
                  </div>
                </template>
                <v-btn
                  v-else
                  depressed
                  large
                  dark
                  ripple
                  :color="theme.color"
                  :loading="
                    loadingCart || checkoutLoading || loadingPageProfile
                  "
                  @click="checkout(true)"
                  class="ma-0"
                  :disabled="isCartOutOfStock"
                  style="width: 100%; border-radius: 0px; height: 55px"
                  :style="{
                    'padding-bottom': $store.getters.getIosPadding
                      ? '15px'
                      : '0'
                  }"
                >
                  <v-icon>mdi-cart-plus</v-icon>&nbsp;
                  <template v-if="$store.state.cds.includes(pageid)"
                    >OK</template
                  >
                  <template v-else>{{ $t('Proceed Checkout') }}</template>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-card>
      </div>
      <!-- End of Checkout detail -->

      <!-- Page Content -->
      <div v-show="!showProductModal && !showModal">
        <div class="container" v-if="productLoading">
          <sync-loader
            :loading="productLoading"
            :key="theme.color"
            :color="theme.color"
            :size="'10px'"
            style="
              position: absolute;
              top: 50%;
              margin-top: -10px;
              left: 50%;
              margin-left: -21px;
            "
          ></sync-loader>
        </div>
        <div v-else>
          <!-- Header -->
          <merchant-detail
            v-model="pageProfile"
            id="merchant"
            :showSearch="showSearch"
          >
            <template>
              <template slot="category">
                <v-tabs
                  show-arrows
                  v-model="selectedCategoryIndex"
                  :slider-color="theme.color"
                  active-class="v-tabs__item--active primary lighten-1 white--text"
                >
                  <template v-for="(category, cindex) in filterCategory">
                    <template>
                      <v-tab
                        show-arrows
                        :key="'category_' + cindex"
                        ripple
                        @click="onChangeCategory(category)"
                        >{{ category.title }}</v-tab
                      >
                    </template>
                  </template>
                </v-tabs>
              </template>
              <template slot="search">
                <v-text-field
                  ref="search"
                  :color="theme.color"
                  v-if="showSearch"
                  :placeholder="$t('Search in') + ' ' + currentCategory.title"
                  @keypress.enter="handleKeypressEnterSearch"
                  @input="handleInputSearch"
                  v-model="search"
                ></v-text-field>
                <v-btn icon @click="openSearch">
                  <v-icon v-if="!showSearch">mdi-magnify</v-icon>
                  <v-icon v-else>mdi-close</v-icon>
                </v-btn>
              </template>
            </template>
          </merchant-detail>

          <!-- Products List -->
          <v-content class="mb-5">
            <!-- Back to catogory list -->
            <div
              class="ml-4"
              v-if="
                !hideProduct &&
                selectedCategory &&
                selectedCategory.slug == 'promotion' &&
                !productListLoading
              "
            >
              <v-btn color="grey lighten-2" icon @click="hideProduct = true">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              &nbsp;ย้อนกลับ
            </div>
            <div v-if="productListLoading">
              <sync-loader
                :loading="productListLoading"
                :key="theme.color"
                :color="theme.color"
                :size="'10px'"
                style="margin-top: 15%; margin-left: 50%"
              ></sync-loader>
            </div>
            <v-container v-else grid-list-md>
              <v-alert
                :value="true"
                v-if="
                  pageProfile && $store.state.cds.includes(pageProfile.pageid)
                "
                color="info"
                icon="info"
                outline
                >กรุณากดปุ่ม "สรุปยอดสินค้า/Checkout" ด้านล่าง
                เพื่อยืนยันการสั่งซื้อ</v-alert
              >

              <v-layout wrap row v-else>
                <template v-if="products.length > 0 || promotions.length > 0">
                  <template v-if="!hideProduct && products.length > 0">
                    <template v-for="(product, pindex) in products">
                      <product
                        :key="'product_' + products[pindex].sku"
                        v-model="products[pindex]"
                        @selectProduct="onSelectProduct(products[pindex])"
                      ></product>
                    </template>
                    <v-flex xs12>
                      <div class="text-xs-center mt-4 mb-4">
                        <v-pagination
                          :color="theme.color"
                          v-model="pageNumber"
                          @input="handlePage"
                          :length="pageCount"
                        ></v-pagination>
                      </div>
                    </v-flex>
                  </template>
                  <!-- Promotion -->
                  <template v-else>
                    <template v-for="(promotion, pmtindex) in promotions">
                      <Promotion
                        :key="'promotion_' + pmtindex"
                        :promotion="promotion"
                        @click.native="onChangePromotion(promotion)"
                      ></Promotion>
                    </template>
                    <v-flex xs12>
                      <div class="text-xs-center mt-4 mb-4">
                        <v-pagination
                          :color="theme.color"
                          v-model="pageNumber"
                          :length="pageCount2"
                        ></v-pagination>
                      </div>
                    </v-flex>
                  </template>
                </template>
                <template v-else>
                  <div class="text-xs-center" style="margin: 25px auto">
                    <img
                      src="@/assets/img/ecommerce/empty_shopping_cart@4x.png"
                      alt
                      style="width: 100px; margin-bottom: 10px"
                    />
                    <h4>{{ $t('No product') }}</h4>
                  </div>
                </template>
              </v-layout>
              <div
                class="text-xs-center"
                style="padding-top: 15px; padding-bottom: 15px"
              >
                <a
                  href="javascript:void(0);"
                  @click="openTerm()"
                  style="color: rgb(169, 169, 169)"
                  >{{ $t('Terms & Condition & Refund Prolicy') }}.</a
                >
              </div>
            </v-container>
          </v-content>

          <!-- Checkout footer -->
          <template>
            <v-bottom-nav
              :value="true"
              :color="theme.color"
              dark
              style="height: 68px; z-index: 3"
              :style="{
                'padding-bottom': $store.getters.getIosPadding ? '15px' : '0',
                position: 'fixed'
              }"
            >
              <v-btn flat value="nearby" @click="openModal">
                <span>{{ $t('Checkout') }} </span>
                <v-badge color="red">
                  <template v-slot:badge v-if="totalItem > 0">
                    <span>{{ totalItem }}</span>
                  </template>
                  <v-icon>mdi-cart-plus</v-icon>
                </v-badge>
              </v-btn>
            </v-bottom-nav>
          </template>
        </div>
      </div>
      <!-- End of Page Content -->

      <Loading v-if="checkoutLoading"></Loading>

      <!-- Facebook Auth -->
      <v-dialog :value="showRedirectToSocial" max-width="400">
        <v-card>
          <v-card-title>
            <span class="headline" :style="{ color: theme.color }">
              {{ $route.query.testbot ? 'หมายเหตุ' : $t('Login to checkout') }}
            </span>
            <v-spacer></v-spacer>
            <v-btn flat fab small @click="showRedirectToSocial = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text :class="$route.query.testbot ? 'pt-0' : ''">
            <div class="text-xs-center">
              <div v-if="!$route.query.testbot">
                <v-btn
                  :href="redirecturl"
                  :color="'#2975eb'"
                  dark
                  class="mb-4"
                  large
                >
                  <img
                    src="@/assets/img/social/icon-facebook.png"
                    alt="facebook button"
                    style="width: 16px; margin-right: 10px"
                  />
                  <span>{{ $t('Sign in with Facebook') }}</span>
                </v-btn>
              </div>
              <div v-else>
                ในส่วนนี้ใช้สำหรับในการทดสอบบอทเบื้องต้นเท่านั้น
                หากต้องการทดสอบการสั่งซื้ออย่างเต็มรูปแบบ
                สามารถทดสอบผ่านทางกล่องข้อความของเพจ
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- End of Facebook Auth -->

      <!-- Dialog for Term and Condition -->
      <term-and-condition
        :pageid="pageProfile.pageid"
        v-if="showTerm"
        @close="closeTerm()"
      ></term-and-condition>
      <!-- End of Dialog for Term and Condition -->
    </div>
  </v-app>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import { mapGetters } from 'vuex'
import mockdata from './test'
import moment from 'moment'

// Components
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import MerchantDetail from '@/components/ecommerce/MerchantDetail'
import CheckoutItem from '@/components/ecommerce/CheckoutItem.vue'
import Product from './Product.vue'
import Promotion from './Promotion.vue'
import ModalProduct from './ModalProduct.vue'
import Loading from '@/components/Loading.vue'
import TermAndCondition from '@/components/ecommerce/TermAndCondition.vue'
import { thailandpostmartApi } from '../../api/thailandpostmart'
export default {
  mixins: [mockdata],
  components: {
    MerchantDetail,
    Product,
    SyncLoader,
    ModalProduct,
    CheckoutItem,
    Loading,
    TermAndCondition,
    Promotion
  },
  data() {
    return {
      pageid: config.thailandpostmart.pageid,
      filterCategory: [],
      selectedCategory: null,
      selectedCategoryIndex: 0,
      showSearch: false,
      search: '',
      products: [],
      total: 0,
      productCount: 0,
      size: 20,
      pageNumber: 1,
      showModal: false,
      showProductModal: false,
      productLoading: false,
      productListLoading: false,
      currentProduct: null,
      checkoutLoading: false,
      voucher: null,
      timestamp: moment().format('x'),
      currencySign: '฿',
      showTerm: false,
      showRedirectToSocial: false,
      redirecturl: null,
      promotions: [],
      hideProduct: false,
      loadingShowProduct: false,
      searchTimeout: null
    }
  },
  computed: {
    ...mapGetters({
      cart: 'getCart',
      isWholesale: 'getWholesaleStatus',
      wholesale: 'getWholesale',
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme'
    }),
    currentCategory() {
      return this.selectedCategory
    },
    pageCount() {
      let l = this.total
      let s = this.size
      return Math.ceil(l / s)
    },
    pageCount2() {
      let l = this.promotions.length
      let s = this.size
      return Math.ceil(l / s)
    },
    isCartOutOfStock() {
      return false
    },
    totalPrice() {
      if (this.voucher) {
        return this.voucher.lasttotal
      }
      if (this.cart.length > 0) {
        let total = this.cart
          .map((d) => d.bundleprice)
          .reduce((total, val) => {
            return total + val
          })
        return total
      } else {
        return 0
      }
    },
    totalItem() {
      let total = 0
      if (this.cart.length > 0) {
        total = this.cart
          .map((el) => {
            return parseInt(el.quantity)
          })
          .reduce((prev, cur) => {
            return prev + cur
          })
      } else {
        total = 0
      }
      return total
    },
    filterCart() {
      return this.cart
    }
  },
  async mounted() {
    const vm = this
    vm.initial()
    await vm.getCategory()
    await vm.handleCheckView()

    if (vm.$route.query.search) {
      vm.search = vm.$route.query.search
      vm.showSearch = true
      vm.$nextTick(() => {
        if (vm.$refs.search) {
          vm.$refs.search.focus()
        }
        vm.handlePage()
      })
    }
  },
  methods: {
    handleSearchProduct() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      this.searchTimeout = setTimeout(() => {
        this.pageNumber = 1
        this.handlePage()
      }, 1000)
    },
    handleKeypressEnterSearch() {
      this.handleSearchProduct()
    },
    handleInputSearch() {
      this.handleSearchProduct()
    },
    async initial() {
      const vm = this

      try {
        localStorage.removeItem('cartarray')
        vm.loadingCart = true
        vm.userAgent = navigator.userAgent
        await vm.$store.dispatch('loadPageProfile', vm.pageid)
        vm.hasVoucher = vm.pageProfile.ispromocode
        document.title = vm.pageProfile.pagename
        vm.pageid = vm.pageProfile.pageid
        await vm.$store.dispatch('updateShopColor', vm.pageProfile.shopcolor)
        if (vm.$route.query.userid) {
          vm.userid = vm.$route.query.userid
          vm.$store.dispatch('setLang', vm.pageProfile.shoplang)
        }
        if (vm.pageProfile.wholesale_status === true) {
          await vm.$store.dispatch('getWholeSale', vm.pageProfile.pageid)
        }
        await vm.$store.dispatch('loadThailandPostMartCart', this.userid)
      } catch (error) {
        console.error(error)
      } finally {
        vm.loadingCart = false
      }
    },
    async handleCheckView() {
      const vm = this
      vm.productLoading = true
      if (vm.$route.query && vm.$route.query.pid) {
        const productId = vm.$route.query.pid

        const product = await vm.getProductDetailBySku(productId)

        if (
          (vm.$route.query.view && vm.$route.query.view === 'cart') ||
          (vm.$route.query.tab && vm.$route.query.tab === 'cart')
        ) {
          if (product) {
            let selectOptionTitle = product.selectedOption
              ? `${product.selectedOption.option1.title} / ${product.selectedOption.option2.title} / ${product.selectedOption.option3.title}`
              : 'Normal'

            let item = {
              quantity: parseInt(1),
              currency: 'THB',
              categoryid: 0,
              description: product.description,
              id: product.sku,
              name: product.product_title,
              pageid: vm.$store.state.pageProfile.pageid,
              photourl: product.product_thumb,
              price: product.product_sale_net,
              productStock: {
                id: product.sku,
                type: selectOptionTitle,
                quantity: vm.productstock
              },
              selectedOption: product.selectedOption
                ? product.selectedOption
                : null,
              discountprice: product.product_price,
              weight: 0
            }

            if (!product.product_attribute) {
              await vm.addToCart({ item: item })

              await vm.$nextTick()
              vm.openModal()
            } else {
              vm.onSelectProduct(product)
            }
          }
        } else if (
          (vm.$route.query.view && vm.$route.query.view === 'detail') ||
          (vm.$route.query.tab && vm.$route.query.tab === 'detail')
        ) {
          vm.onSelectProduct(product)
        } else if (product) {
          // in case we have only pid
          vm.onSelectProduct(product)
        }
        vm.$route.query.pid = ''
      }
      vm.productLoading = false
    },
    async getCategory() {
      this.productLoading = true
      const pageid = config.thailandpostmart.pageid.pagename
      let response = await axios.get(
        config.thailandpostmart.serverUrl + `category?pageid=${pageid}`,
        { headers: config.thailandpostmart.auth }
      )
      if (response.data.responsecode == 200) {
        this.filterCategory = response.data.data

        if (this.$route.query.category) {
          let selectedCategory = this.$route.query.category
          this.selectedCategory = this.filterCategory.find(
            (el) => el.slug == selectedCategory
          )
          this.selectedCategoryIndex = this.filterCategory.findIndex(
            (c) => c.slug === selectedCategory
          )
        } else {
          this.selectedCategory = this.filterCategory[0]
        }

        await this.getProductByCategory(this.selectedCategory.slug)
        this.productLoading = false
      }
    },
    async getProductByCategory(slug, page = 1) {
      this.productListLoading = true
      const pageid = config.thailandpostmart.pageid.pagename
      let response = await axios.get(
        config.thailandpostmart.serverUrl + `category/${slug}`,
        {
          headers: config.thailandpostmart.auth,
          params: {
            pageid,
            per_page: this.size,
            pages: page,
            search: this.search
          }
        }
      )
      if (response.data.responsecode == 200) {
        this.products = response.data.data
        this.total = response.data.total
        this.productCount = this.products.length
        this.productListLoading = false
      }
    },
    async handlePage() {
      try {
        this.productListLoading = true
        await this.getProductByCategory(
          this.selectedCategory.slug,
          this.pageNumber
        )
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      } finally {
        this.productListLoading = false
      }
    },
    async getPromotionCategory() {
      this.productListLoading = true
      const pageid = config.thailandpostmart.pageid.pagename
      let response = await axios.get(
        config.thailandpostmart.serverUrl + `promotion?pageid=${pageid}`,
        { headers: config.thailandpostmart.auth }
      )
      if (response.data.responsecode == 200) {
        this.promotions = response.data.data
        this.productListLoading = false
        this.hideProduct = true
      }
    },
    async onChangeCategory(category) {
      if (category) {
        this.pageNumber = 1
        this.selectedCategory = category
        if (category.slug == 'promotion') {
          await this.getPromotionCategory()
        } else {
          this.hideProduct = false
          await this.getProductByCategory(category.slug)
        }
      }
    },
    async onChangePromotion(promotion) {
      this.productListLoading = true
      const pageid = config.thailandpostmart.pageid.pagename
      let response = await axios.get(
        config.thailandpostmart.serverUrl +
          `promotion/${promotion.promotion_id}?pageid=${pageid}`,
        { headers: config.thailandpostmart.auth }
      )
      if (response.data.responsecode == 200) {
        this.products = response.data.data
        this.productListLoading = false
        this.hideProduct = false
      }
    },
    openSearch() {
      this.showSearch = !this.showSearch
      if (this.showSearch) {
        this.$nextTick(() => this.$refs.search.focus())
      } else {
        this.search = ''
      }
    },
    async onSelectProduct(product) {
      this.currentProduct = product
      await this.$nextTick()
      this.showProductModal = true
      await this.$nextTick()
      this.$vuetify.goTo(0, {
        duration: 0,
        offset: 0,
        easing: 'linear'
      })
      window.history.pushState({ modal: 'open' }, '', '#modal-open')
      // window.location.hash = "#modal-open";
      window.onpopstate = (event) => {
        if (event.state && event.state.modal == 'open') {
          // console.log('test')
        } else {
          this.showProductModal = false
          this.showModal = false
        }
      }
    },
    openModal() {
      this.showModal = true
      let vm = this
      window.history.pushState({ modal: 'open' }, '', '#modal-open')
      // window.location.hash = "#modal-open";
      window.onpopstate = function (event) {
        if (event.state && event.state.modal == 'open') {
          // console.log('test')
        } else {
          vm.showModal = false
          vm.showProductModal = false
        }
      }
    },
    close() {
      this.showModal = false
      if (window.history.length != 0) {
        window.history.back()
      }
    },
    async addToCart({ item, loading }) {
      try {
        let tmp = {
          ...item,
          category: this.selectedCategory.slug,
          optionid: item.productStock.id,
          option: item.productStock.type,
          max: item.productStock.quantity,
          productid: item.id,
          optionDetail: item.selectedOption
        }

        await this.$store.dispatch('addToCart', {
          product: tmp,
          userId: this.userid
        })
        if (this.voucher) {
          this.voucher.onUpdate()
        }
      } catch (error) {
        if (error.data.reason) {
          this.$swal({
            title: this.$t(error.data.reason),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('Cancel'),
            reverseButtons: true
          })
        }
      } finally {
        if (loading) {
          loading()
        }
      }
    },
    async closeProduct() {
      this.showProductModal = false
      await this.$nextTick()
      this.$vuetify.goTo(10, {
        duration: 100,
        offset: 0,
        easing: 'linear'
      })
      await this.$nextTick()
      this.$vuetify.goTo(0, {
        duration: 100,
        offset: 0,
        easing: 'linear'
      })
    },
    async openCheckout() {
      this.closeProduct()
      await this.$nextTick()
      this.showModal = true
    },
    onUpdateStock() {
      if (this.voucher) {
        this.voucher.onUpdate()
      }
      this.timestamp = moment().format('x')
    },
    async showProduct(payload) {
      this.showModal = false
      this.productLoading = true
      await this.getProductByCategory(payload.category)
      this.productLoading = false
      let product = this.products.find((el) => {
        return el.sku == payload.id
      })
      if (product) {
        var newProduct = { ...product }
        newProduct.showBack = true
        this.onSelectProduct(newProduct)
      }
    },
    onFilterProducts() {
      let filteredProducted = this.products
      if (this.search != '' && filteredProducted) {
        filteredProducted = filteredProducted.filter((f) =>
          f.product_title.toLowerCase().includes(this.search.toLowerCase())
        )
      }
      return filteredProducted
    },
    deleteItemInCart(index) {
      var vm = this
      vm.deleteIndex = index
      vm.$swal({
        title: vm.$t('Do you want to remove this') + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('Cancel'),
        reverseButtons: true
      }).then(async function (result) {
        if (result.value) {
          await vm.$store.dispatch('thailandpostmartDeleteFromCart', {
            index,
            userId: vm.userid
          })
        }
        if (vm.voucher) {
          vm.voucher.onUpdate()
        }
      })
    },

    async checkout(isClose) {
      const vm = this
      let isSkip = !['cds'].includes(vm.pageProfile.type)

      if (!vm.filterCart) {
        return false
      }
      vm.checkoutLoading = true
      let data = {
        cartarray: []
      }

      data.cartarray = vm.filterCart.map((val) => {
        let option = {
          pid: val.id,
          qty: val.quantity,
          option: val.option,
          cart_remark: val.cart_remark
          // photourl: val.photourl,
        }
        return option
      })

      localStorage.setItem('cartarray', JSON.stringify(data.cartarray))

      let responseVerify = await vm.THPostMartVerifyCart()

      isClose = isClose ? isClose : false
      if (isClose && responseVerify) {
        await thailandpostmartApi.checkoutCart({
          page_id: vm.pageProfile.pageid,
          social_id: vm.userid,
          orderdetails: vm.cart.map((item) => ({
            sku: item.id,
            quantity: item.quantity
          }))
        })

        if (isSkip) {
          vm.$router.push({
            name: 'transfer',
            params: { id: vm.pageProfile.pageid },
            query: { ...this.$route.query, lang: this.currentLang }
          })
        } else {
          if (this.$route.query.app == 'line') {
            vm.$liff.closeWindow()
          } else {
            // eslint-disable-next-line
            MessengerExtensions.requestCloseBrowser(
              function success() {},
              function error() {
                window.close()
              }
            )
          }
        }
      }
    },
    async THPostMartVerifyCart() {
      const vm = this
      let cart = vm.cart
      let orderdetails = []

      if (cart) {
        orderdetails = cart.map((item) => ({
          sku: item.selectedOption ? item.selectedOption.option1.sku : item.id,
          sku_gift:
            item.selectedOption && item.selectedOption.option2
              ? item.selectedOption.option2.sku
              : '',
          sku_gift_enforce:
            item.selectedOption && item.selectedOption.option3
              ? item.selectedOption.option3.sku
              : '',
          quantity: item.quantity,
          amount: item.priceBeforeVat
        }))
      }

      let data = {
        address: {
          social_id: '',
          facebook_id: '',
          name: '',
          address: '',
          phone: '',
          email: '',
          postcode: ''
        },
        orderdetails: orderdetails,
        ticket_code: this.voucherCode ? this.voucherCode : '',
        page_id: this.pageProfile.pageid
      }

      let url = `${config.thailandpostmart.serverUrl}cart/verify`
      let auth = config.thailandpostmart.auth
      let result = null

      try {
        let response = await axios.post(url, data, {
          headers: auth
        })

        if (response && response.data.responsecode == '200') {
          result = response.data.data
          this.$store.state.thpostmartVerifyCartResult = result
        } else {
          vm.loading = false
          this.$swal({
            title: vm.$t('Error'),
            text: response.data.reason.res
              ? response.data.reason.res
              : response.data.reason,
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('Cancel'),
            reverseButtons: true
          })
        }
      } catch (error) {
        /* eslint-disable */
        console.log(error)
      }

      return result
    },
    openTerm() {
      this.showTerm = true
      let vm = this
      window.history.pushState({ modal: 'open' }, '', '#modal-open')
      // window.location.hash = "#modal-open";
      window.onpopstate = function (event) {
        if (event.state && event.state.modal == 'open') {
          // console.log('test')
        } else {
          vm.showTerm = false
        }
      }
    },
    closeTerm() {
      var vm = this
      if (window.history.length == 0) {
        vm.showTerm = false
      } else {
        window.history.back()
      }
    },
    async getProductDetailBySku(sku) {
      try {
        const pageid = config.thailandpostmart.pageid.pagename
        const url = `${config.thailandpostmart.serverUrl}product/${sku}?pageid=${pageid}`
        const response = await axios.get(url, {
          headers: config.thailandpostmart.auth
        })

        if (response && response.status === 200) {
          return response.data.data
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}
</script>
